import React from 'react';
import QuestionnaireStopperV2 from '../questionnaire_stopper_v2';

const NoMentorFoundMessage = ({ heading, body }) => (
  <QuestionnaireStopperV2 detailed={true} heading={heading} body={body} />
);

export default NoMentorFoundMessage;
